/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 51ff70b15746de9a67dcfcd32140723b */

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type GuildTypes = "GUILD" | "NETWORK" | "%future added value";
export type GuildNavigatorQueryVariables = {
    id: string;
};
export type GuildNavigatorQueryResponse = {
    readonly nodeBySlugId: ({
        readonly __typename: "Guild";
        readonly id: string;
        readonly slugId: string;
        readonly type: GuildTypes | null;
        readonly myMembership: {
            readonly id: string;
        } | null;
        readonly minimumDonationAmount: number | null;
        readonly donationCurrency: string | null;
        readonly totalNetworks: {
            readonly totalCount: number;
        };
        readonly totalGuilds: {
            readonly totalCount: number;
        };
        readonly totalEvents: {
            readonly totalCount: number;
        };
        readonly totalPresentations: {
            readonly totalCount: number;
        };
        readonly " $fragmentRefs": FragmentRefs<"GuildCard_guild" | "GuildMetadata_guild" | "GuildJoinConfirmation_guild" | "GuildJoinConfirmationContent_guild">;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    }) | null;
};
export type GuildNavigatorQuery = {
    readonly response: GuildNavigatorQueryResponse;
    readonly variables: GuildNavigatorQueryVariables;
};



/*
query GuildNavigatorQuery(
  $id: String!
) {
  nodeBySlugId(id: $id) {
    __typename
    ... on Guild {
      id
      slugId
      type
      myMembership {
        id
      }
      minimumDonationAmount
      donationCurrency
      ...GuildCard_guild
      ...GuildMetadata_guild
      ...GuildJoinConfirmation_guild
      ...GuildJoinConfirmationContent_guild
      totalNetworks: rankedNetworks(membershipStatus: ACCEPTED) {
        totalCount
      }
      totalGuilds: rankedNetworkGuilds(membershipStatus: ACCEPTED) {
        totalCount
      }
      totalEvents: events {
        totalCount
      }
      totalPresentations: presentations {
        totalCount
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment GraphQLImage_image on Image {
  url
}

fragment GuildCard_guild on Guild {
  slugId
  rowId
  name
  description
  type
  myMembership {
    membershipLevel
    id
  }
  ...GuildMembershipStatus_guild
  ...GuildJoinConfirmationContent_guild
  ...GuildPrimaryPhoto_guild
  primaryPhoto {
    id
  }
  backgroundPhoto {
    ...GraphQLImage_image
    id
  }
}

fragment GuildJoinConfirmationContent_guild on Guild {
  name
  rowId
  slugId
}

fragment GuildJoinConfirmation_guild on Guild {
  myMembership {
    membershipLevel
    id
  }
  ...GuildJoinConfirmationContent_guild
}

fragment GuildMembershipStatus_guild on Guild {
  myMembership {
    membershipLevel
    id
  }
  networkMembers {
    totalCount
  }
}

fragment GuildMetadata_guild on Guild {
  slugId
  name
  description
}

fragment GuildPrimaryPhoto_guild on Guild {
  type
  primaryPhoto {
    ...GraphQLImage_image
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v6 = [
  (v3/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minimumDonationAmount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "donationCurrency",
  "storageKey": null
},
v9 = [
  {
    "kind": "Literal",
    "name": "membershipStatus",
    "value": "ACCEPTED"
  }
],
v10 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
],
v11 = {
  "alias": "totalNetworks",
  "args": (v9/*: any*/),
  "concreteType": "GuildsConnection",
  "kind": "LinkedField",
  "name": "rankedNetworks",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": "rankedNetworks(membershipStatus:\"ACCEPTED\")"
},
v12 = {
  "alias": "totalGuilds",
  "args": (v9/*: any*/),
  "concreteType": "GuildsConnection",
  "kind": "LinkedField",
  "name": "rankedNetworkGuilds",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": "rankedNetworkGuilds(membershipStatus:\"ACCEPTED\")"
},
v13 = {
  "alias": "totalEvents",
  "args": null,
  "concreteType": "EventsConnection",
  "kind": "LinkedField",
  "name": "events",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v14 = {
  "alias": "totalPresentations",
  "args": null,
  "concreteType": "PresentationsConnection",
  "kind": "LinkedField",
  "name": "presentations",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v15 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  },
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GuildNavigatorQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodeBySlugId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GuildMembership",
                "kind": "LinkedField",
                "name": "myMembership",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              (v7/*: any*/),
              (v8/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GuildCard_guild"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GuildMetadata_guild"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GuildJoinConfirmation_guild"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GuildJoinConfirmationContent_guild"
              }
            ],
            "type": "Guild",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GuildNavigatorQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodeBySlugId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GuildMembership",
                "kind": "LinkedField",
                "name": "myMembership",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "membershipLevel",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rowId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UsersConnection",
                "kind": "LinkedField",
                "name": "networkMembers",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "primaryPhoto",
                "plural": false,
                "selections": (v15/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "backgroundPhoto",
                "plural": false,
                "selections": (v15/*: any*/),
                "storageKey": null
              },
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/)
            ],
            "type": "Guild",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v6/*: any*/),
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "d04ea61996b44e99bcd5518d359539963cd80c5ffc77c7e9198980a5d769bdfe",
    "metadata": {},
    "name": "GuildNavigatorQuery",
    "operationKind": "query",
    "text": null
  }
};
})();
(node as any).hash = 'dd584b49ef141df9f59397437e9902be';
export default node;
